export const workloadVpaFormSettings = [
  'optimizedResources',
  'customMetrics',
  'excludedContainers',
  'autoscaler',
  'predictiveScaling',
  'overhead',
  'memoryGrowthDetection',
  'stallDetection',
  'recommendationPercentile',
  'workloadResourceLimits',
  'workloadConstraints',
  'lookbackPeriod',
  'startupMetrics',
  'hpaConverter',
] as const;

export type WorkloadVpaFormSettings = (typeof workloadVpaFormSettings)[number];
